const fetchWordpress = require('../api/wordpress');

async function fetchWordpressByPage(
  type,
  segment,
  offset,
  data = [],
  idx = 1,
  count = 0
) {
  const query = `/${type}${
    type.includes('?') ? '&' : '?'
  }per_page=${segment}&order=desc${offset ? `&offset=${offset}` : ''}`;
  try {
    const fetchData = await fetchWordpress(query);
    if (fetchData[0]) {
      const accumulatedData = [...data, { page: idx, data: fetchData }];
      return await fetchWordpressByPage(
        type,
        segment,
        offset ? offset + segment : segment,
        accumulatedData,
        idx + 1
      );
    }
    return data;
  } catch (e) {
    if (count > 10) {
      return [];
    }
    const dataRound2 = await new Promise(resolve => {
      setTimeout(async () => {
        const res = await fetchWordpressByPage(
          type,
          segment,
          offset ? offset + segment : segment,
          data,
          idx,
          count + 1
        );
        resolve(res);
      }, 1000);
    });
    return dataRound2;
  }
}

async function fetchAllWordpress(type, offset, data = []) {
  try {
    const query = `/${type}${
      type.includes('?') ? '&' : '?'
    }per_page=100&order=desc${offset ? `&offset=${offset}` : ''}`;
    const fetchData = await fetchWordpress(query);
    if (fetchData[0]) {
      const accumulatedData = [...data, ...fetchData];
      return await fetchAllWordpress(
        type,
        offset ? offset + 100 : 100,
        accumulatedData
      );
    }
    return data;
  } catch (e) {
    console.log('\x1b[31m', 'error', '\x1b[37m', type, e);
    throw e;
  }
}

module.exports = {
  fetchWordpressByPage: async (type, segment) =>
    fetchWordpressByPage(type, segment),
  fetchAllWordpress: async type => fetchAllWordpress(type)
};
